<style>
    .error-page__list {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
    }

    .error-page__list p,
    .error-page__list h3,
    .error-page__list ul {
        margin-right: 0.5rem;
        width: calc(50% - 0.5rem);
        flex-grow: 1;
        word-break: break-word;
    }

    .error-page__list p {
        margin-bottom: 1rem;
    }

    .error-page__list h3 {
        margin: 0;
        padding-bottom: 0.25rem;
    }

    .error-page__list .icon {
        padding-right: 0.5rem;
    }

    .error-page__list a {
        font-weight: 500;
    }

    .error-page h1 {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .error-page h1 .icon {
        margin-right: 0.5rem;
    }
</style>

<main>
    <div class="l-container l-container--m error-page">

        <h1>
            <svg class="icon h-color-error">
                <use xlink:href="#icon-info"></use>
            </svg>
            <span>Es ist ein Fehler aufgetreten.</span>
        </h1>

        <h2 class="h-spacer-m h-text-center h-font-l">Versuchen Sie es bitte später nochmal.</h2>

        <div class="h-spacer-l error-page__list">

            <h3 class="h-text-left h-font-m">Unsere Telefon-Hotline</h3>
            <h3 class="h-text-left h-font-m">Schreiben Sie uns</h3>

            <p class="h-text-left h-font-m h-font-regular h-color-black">
                <span>
                    <svg class="icon h-color-pri-dark">
                        <use xlink:href="#icon-telephone"></use>
                    </svg>
                    <span class="h-font-l h-color-pri-dark">{{getStatischenText('KundenserviceTelefonnummer')}}</span>
                </span>
                <br>
                <span class="h-font-light">
                    {{getStatischenText('KundenserviceOeffnungszeiten')}}
                </span>
            </p>


            <p class="h-text-left h-font-m h-font-regular h-color-black">
                <span>
                    <svg class="icon h-color-pri-dark">
                        <use xlink:href="#icon-email"></use>
                    </svg>
                    <span><a href="https://www.vhv.de/vhv/formular-e-mail-kontakt.htm">Kontakt-Formular</a></span>
                </span>
            </p>

            <h3 class="h-text-left h-font-m">Privatkunden</h3>
            <h3 class="h-text-left h-font-m">Firmenkunden</h3>

            <ul>
                <li><a href="https://www.vhv.de">Startseite</a></li>
                <li><a href="https://www.vhv.de/kundenservice">Kundenservice</a></li>
                <li><a href="https://www.vhv.de/kontakt">Kontakt</a></li>
                <li><a href="https://www.vhv.de/unternehmen">Unternehmensinfos</a></li>
            </ul>

            <ul>
                <li><a href="https://www.vhv.de/firmen">Startseite</a></li>
                <li><a href="https://www.vhv.de/firmen/kundenservice">Kundenservice</a></li>
                <li><a href="https://www.vhv.de/firmen/meta/sitemap">Seitenübersicht</a></li>
            </ul>

        </div>

    </div>
</main>
